// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__wixwr","selects":"Documents_selects__1ucMB"};